module.exports = __webpack_public_path__ + "img/maison13.39c9dd8d.jpg";